"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrderRatingMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class AddOrderRatingMapper {
    toDomain(result) {
        const { id, idOrder, created } = lodash_1.default.get(result, "data.orderRating");
        return {
            id,
            idOrder,
            created
        };
    }
}
exports.AddOrderRatingMapper = AddOrderRatingMapper;
